import { API_BASE, request } from './api-client';
import type { AdminUserSession } from '../types';

const BASE = `${API_BASE}/admin/users-mgmt`;

export function listSessions(userId: string) {
  return request<AdminUserSession[]>(`${BASE}/${userId}/sessions`);
}

export function forceLogout(userId: string) {
  return request<{ revoked: number }>(`${BASE}/${userId}/force-logout`, { method: 'POST' });
}

export function generateResetLink(userId: string) {
  return request<{ link: string }>(`${BASE}/${userId}/reset-password`, { method: 'POST' });
}
